import { render } from "./PastBillings.vue?vue&type=template&id=19a37a3e&scoped=true"
import script from "./PastBillings.vue?vue&type=script&lang=js"
export * from "./PastBillings.vue?vue&type=script&lang=js"

import "ag-grid-community/dist/styles/ag-theme-alpine.css?vue&type=style&index=0&lang=css"
import "ag-grid-community/dist/styles/ag-grid.css?vue&type=style&index=1&lang=css"
import "./PastBillings.vue?vue&type=style&index=2&id=19a37a3e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4281202222/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a37a3e"]])

export default __exports__